const IntegrationType = {
  CLIENT_SIDE_ENCRYPTION: 'client_side_encryption',
  CMS_MODULE: 'cms_module',
  DIRECT_API: 'direct_api',
  HOSTED_ELEMENTS: 'hosted_elements',
  HOSTED_FIELDS: 'hosted_fields',
  HOSTED_PAGE: 'hosted_page',
  OTHER: 'other',
};

module.exports = IntegrationType;
